import React, {Fragment} from 'react';
import {getFormattedDate} from "@utils";
import {FormattedDate, FormattedTime} from 'react-intl';


interface Props {
  date: string,
  showTime?: Boolean
}


/**
 * This class shows a date-time
 * @param date
 * @param showTime
 */
export default function ({date, showTime = true}: Props): JSX.Element {
  return (
    <span dir={"ltr"}>
      {getFormattedDate({date, showTime})}
      {/*{showTime && (*/}
        {/*<Fragment>*/}
          {/*<FormattedTime value={getFormattedDate(date)}/>*/}
          {/*{"  "}*/}
        {/*</Fragment>*/}
      {/*)}*/}
      
      {/*<FormattedDate value={getFormattedDate(date)}/>*/}
    
    </span>
  )
};